import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptureVoiceComponent } from './capture-voice/capture-voice.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CaptureVoiceComponent,
  ],
  exports: [
    CaptureVoiceComponent,
  ]
})
export class IoAudioModule { }
